<script setup>
import OfModal from "@dk.onlinefundraising/vue-utils/src/utils/OfModal.vue";
import { ref, defineEmits } from "vue";
import OfUserForm from "./OfUserForm.vue"
import OfButton from "@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue";
import requests from "@/OfOnboardingRequests";

const user = ref({})

const emit = defineEmits(['close', 'reloadList'])

function createUser() {
    requests.createUser(user.value).then((result) => {
        if (result && result.userGuid) {
            emit('getUsers');
            emit('close');
        }
    });
}
</script>
<template>
    <OfModal @close="emit('close')">

        <template #heading>
            Create user
        </template>

        <template #top>

        </template>

        <template #buttons>
            <OfButton coloring="primary" text="Create" @click="createUser()" />
        </template>

        <template #middle>

            <OfUserForm :user="user" />

        </template>

    </OfModal>
</template>